//引入request
import axios from "@/utils/axios";
import Qs from "qs";

export default class CheckService {
  //首页获取精彩看点
  static getViews(videoModule, userId) {
    return axios({
      url: "port/index/getInformationList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ videoModule, userId })
    });
  }
  //获取精彩看点详情
  static getViewsDetail(id, userId) {
    return axios({
      url: "port/index/getBestViewsDetails",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, userId })
    });
  }
  //获取精彩看点列表
  static getBestViewsList(videoModule, pageNum, pageSize, userId, videoClass) {
    return axios({
      url: "port/index/getBestViewsList",
      method: "post",
      // data: { videoModule, pageNum, PageSize, userId }
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ videoModule, pageNum, pageSize, userId, videoClass })
    });
  }
  //获取精彩看点相关推荐
  static getBestViewsRelevantList(videoModule, id) {
    return axios({
      url: "port/index/getBestViewsRelevantList",
      method: "post",
      // data: { videoModule, pageNum, PageSize, userId }
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ videoModule, id })
    });
  }
  //首页获取校园频道列表
  static indexChannelList(status, pageNum, pageSize) {
    return axios({
      url: "port/index/getSchoolList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ status, pageNum, pageSize })
    });
  }
  //首页获取优选活动
  static getIndexActives(userId, pageNum, PageSize) {
    return axios({
      url: "port/index/getActivityList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId, pageNum, PageSize })
    });
  }
  //首页获取直播
  static getIndexLives(recommend, pageNum, PageSize, schoolId) {
    return axios({
      url: "port/index/getLiveStream",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ recommend, pageNum, PageSize, schoolId })
    });
  }

  // 首页获取校园风采
  static getIndexShow(videoModule) {
    return axios({
      url: "port/index/getVLogList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ videoModule })
    });
  }
  //用户点赞/取消点赞(活动)
  static getIndexIslike(likeType, relevanceId, userId) {
    return axios({
      url: "port/index/isMyLikeActivity",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ likeType, relevanceId, userId })
    });
  }
  //用户点赞/取消点赞(视频)
  static isMyLikeVideo(likeType, relevanceId, userId) {
    return axios({
      url: "port/index/isMyLikeVideo",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ likeType, relevanceId, userId })
    });
  }
  //用户收藏/取消收藏
  static getUserCollect(userId, relevanceId, Type, collectType) {
    return axios({
      url: "port/index/getUserCollect",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId, relevanceId, Type, collectType })
    });
  }

  //用户点赞/取消点赞(课程)
  static getisMyLikeSchoolVideo(likeType, relevanceId, userId) {
    return axios({
      url: "port/school/isMyLikeSchoolVideo",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ likeType, relevanceId, userId })
    });
  }

  //评论的点赞和取消
  static getisMyLikeSchoolComment(likeType, relevanceId, userId) {
    return axios({
      url: "port/school/isMyLikeSchoolComment",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ likeType, relevanceId, userId })
    });
  }

  // 小记者-----------------------------------------------------------------------------

  //小记者获取精彩瞬间
  static getInformationList(videoModule, userId) {
    return axios({
      url: "port/reporter/getInformationList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ videoModule, userId })
    });
  }

  //小记者获取优质稿件和小记者在行动
  static getManuscriptList(type) {
    return axios({
      url: "port/reporter/getManuscriptList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ type })
    });
  }
  //小记者获取优质稿件和小记者在行动列表
  static getManuscriptList2(type, pageNum, pageSize, manuscriptClass) {
    return axios({
      url: "port/reporter/getManuscriptList2",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ type, pageNum, pageSize, manuscriptClass })
    });
  }
  //
  //小记者报名
  static ReunifiedOrder(name, sex, age, phone, money, payType) {
    return axios({
      url: "port/wxpay/ReunifiedOrder",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ name, sex, age, phone, money, payType })
    });
  }

  // 校园频道
  //手机端校园频道页查看学校列表接口
  static schoollistType(strudyingPhase, pageNum, pageSize) {
    return axios({
      url: "port/school/listType",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ strudyingPhase, pageNum, pageSize })
    });
  }
  // 校园频道 校园详情 （校名、校徽、校训、封面、简介、图片部分
  static getSchoolDetails(id) {
    return axios({
      url: "/port/school/getSchoolDetails",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }
  // 校园详情页中的精彩推荐（校园频道的睛彩校园、睛彩校园列表）
  static schoolVideos(
    schoolId,
    pageNum,
    pageSize,
    videoModule,
    userId,
    isRecommend
  ) {
    return axios({
      url: "port/school/schoolVideos",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        schoolId,
        pageNum,
        pageSize,
        videoModule,
        userId,
        isRecommend
      })
    });
  }
  // 校园详情中校园资讯内容（校园资讯列表可共用）
  static getschoolManuscript(schoolId, type, pageNum, pageSize) {
    return axios({
      url: "port/school/schoolManuscript",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ schoolId, type, pageNum, pageSize })
    });
  }
  // 获取校园资讯详情
  static getInformationDetail(id, userId) {
    return axios({
      url: "port/index/getInformationDetail",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, userId })
    });
  }
  // 校园详情里的校园栏目列表
  static getschoolColumn(schoolId) {
    return axios({
      url: "port/school/schoolColumn",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ schoolId })
    });
  }
  // 手机端校园详情中点击校园栏目封面跳转某栏目名称下的视频列表
  static schoolColumnVideos(schoolId, columnId, pageNum, pageSize, userId) {
    return axios({
      url: "port/school/schoolColumnVideos",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ schoolId, columnId, pageNum, pageSize, userId })
    });
  }

  // 校园详情中的名师讲堂和跳转后的名师讲堂列表
  static schoolMaginZone(schoolId, pageNum, pageSize, grade, subject) {
    return axios({
      url: "port/school/schoolMaginZone",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ schoolId, pageNum, pageSize, grade, subject })
    });
  }
  // 名师讲堂详情
  static getSchoolMaginZoneDetails(id, userId) {
    return axios({
      url: "port/school/getSchoolMaginZoneDetails",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, userId })
    });
  }
  //手机端查看名师讲堂详情中的课程列表

  static getZoneDetailsZone(id, zoneId) {
    return axios({
      url: "port/school/getZoneDetailsZone",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, zoneId })
    });
  }

  //从名师讲堂课程列表详情
  static getMaginZoneDetails(id, userId) {
    return axios({
      url: "port/school/getMaginZoneDetails",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, userId })
    });
  }

  //名师讲堂详情中相关课程部分
  static getschoolColumnRelevanceVideo(id) {
    return axios({
      url: "port/school/schoolColumnRelevanceVideo",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }

  // 获取各个板块的banner图片
  static getBannerList(bannerLocation) {
    return axios({
      url: "port/school/getViewList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ bannerLocation })
    });
  }
  // 获取活动详情
  static getActivityDetail(id, userId) {
    return axios({
      url: "port/index/getActivityDetail",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, userId })
    });
  }
  // 活动详情中的相关推荐
  static ActivityRelevanceList(id) {
    return axios({
      url: "port/school/getActivityRelevanceList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }

  // 活动详情中的相关推荐
  static ManuScritpRelevantList(id, type) {
    return axios({
      url: "port/index/getManuScritpRelevantList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, type })
    });
  }
  // 获取校园风采列表
  static getSchoolVLogList(videoModule, topicType, pageNum, pageSize, userId) {
    return axios({
      url: "port/school/getSchoolVLogList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ videoModule, topicType, pageNum, pageSize, userId }) //topicType为空是查询全部
    });
  }
  // 手机端获取校园风采详情
  static TvStyleDetail(id, userId) {
    return axios({
      url: "port/school/getTvStyleDetail",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, userId })
    });
  }
  // 校园风采列表中的话题列表
  static getSchoolTopicList(topicType) {
    return axios({
      url: "port/school/getSchoolTopic",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ topicType })
    });
  }
  // 新增评论
  static getAddComment(shareId, userId, content) {
    return axios({
      url: "port/school/addComment",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ shareId, userId, content })
    });
  }
  // 获取用户信息
  static getUserInfo(username) {
    return axios({
      url: "port/user/getUserInfo",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ username })
      // data: Qs.stringify({ username:'17865319186' })
    });
  }

  //新增校园vlog接口
  static getAddTvStyle(
    title,
    topic,
    videoPath,
    videoOrgName,
    coverPath,
    founder
  ) {
    return axios({
      url: "port/school/addTvStyle",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        title,
        topic,
        videoPath,
        videoOrgName,
        coverPath,
        founder
      })
    });
  }
  //名师讲堂合集列表查询年级列表
  static getGradeList(schoolId) {
    return axios({
      url: "port/school/getGradeList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ schoolId })
    });
  }
  //名师讲堂合集列表，根据年级查询学科
  // static getSubjectList(gradeId) {
  //   return axios({
  //     url: "port/school/getSubjectList",
  //     method: "post",
  //     headers: { "Content-Type": "application/x-www-form-urlencoded" },
  //     data: Qs.stringify({ gradeId })
  //   });
  // }

  //视频播放量+1
  static getAddVideoPlayCount(id, type) {
    return axios({
      url: "port/index/addVideoPlayCount",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id, type })
    });
  }
  //稿件浏览量+1
  static getAddManuScriptLikeCount(id) {
    return axios({
      url: "port/index/addManuScriptLikeCount",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }
  //图片上传
  static getUpload(file) {
    return axios({
      url: "port/reporter/upload",
      method: "post",
      // headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: file
    });
  }
  //视频上传
  static uploadPicvideo(file) {
    return axios({
      url: "upload/file/uploadPicvideo",
      method: "post",
      // headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: file
    });
  }
  // 小记者续费 微信
  static getReporterPostponeByWx(
    name,
    sex,
    age,
    phone,
    money,
    payType,
    photo,
    userId,
    schoolName
  ) {
    return axios({
      url: "port/wxpay/reporterPostponeByWx",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        name,
        sex,
        age,
        phone,
        money,
        payType,
        photo,
        userId,
        schoolName
      })
    });
  }

  //小记者续费 支付宝
  static getReporterPostponeByAli(
    name,
    sex,
    age,
    phone,
    money,
    payType,
    photo,
    schoolName,
    userId
  ) {
    return axios({
      url: "port/alipay/reporterPostponeByAli",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        name,
        sex,
        age,
        phone,
        money,
        payType,
        photo,
        schoolName,
        userId
      })
    });
  }

  //小记者报名微信
  static getReunifiedOrderByWx(
    name,
    sex,
    age,
    phone,
    money,
    payType,
    photo,
    schoolId,
    userId,
    fatherName,
    motherName,
    fatherPhone,
    motherPhone,
    isParticipate,
    className
  ) {
    return axios({
      url: "port/wxpay/ReunifiedOrderByWx",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        name,
        sex,
        age,
        phone,
        money,
        payType,
        photo,
        schoolId,
        userId,
        fatherName,
        motherName,
        fatherPhone,
        motherPhone,
        isParticipate,
        className
      })
    });
  }

  //小记者报名支付宝
  static getReunifiedOrderByAli(
    name,
    sex,
    age,
    phone,
    money,
    payType,
    photo,
    schoolId,
    userId,
    fatherName,
    motherName,
    fatherPhone,
    motherPhone,
    isParticipate,
    className
  ) {
    return axios({
      url: "port/alipay/ReunifiedOrderByAli",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        name,
        sex,
        age,
        phone,
        money,
        payType,
        photo,
        schoolId,
        userId,
        fatherName,
        motherName,
        fatherPhone,
        motherPhone,
        isParticipate,
        className
      })
    });
  }
  //活动微信报名
  static getActivityOrderByWx(payType, money, activityId, userId) {
    return axios({
      url: "port/wxpay/ActivityOrderByWx",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        payType,
        money,
        activityId,
        userId
      })
    });
  }
  //活动支付宝报名
  static getActivityOrderByAli(payType, money, activityId, userId) {
    return axios({
      url: "port/alipay/ActivityOrderByAli",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        payType,
        money,
        activityId,
        userId
      })
    });
  }
  //活动免费报名
  static getaddaActivityRecord(userId, activityId) {
    return axios({
      url: "port/reporter/addaActivityRecord",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        userId,
        activityId
      })
    });
  }

  //小记者线索提供
  static getAddClew(title, content, address, coverPath, phone, founder, type) {
    return axios({
      url: "port/reporter/addClew",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({
        title,
        content,
        address,
        coverPath,
        phone,
        founder,
        type
      })
    });
  }

  //判断用户是不是小记者
  static getIsReporter(id) {
    return axios({
      url: "port/user/isReporter",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }

  //注册报名时   判断用户是不是小记者
  static newIsRepoter(id) {
    return axios({
      url: "port/reporter/getIsRepoter",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }

  //小记者投稿
  static getAddContribute(title, content, coverPath, founder, type) {
    return axios({
      url: "port/reporter/addContribute",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ title, content, coverPath, founder, type })
    });
  }
  //获取小记者报名费用
  static ReporterEntryFee(type) {
    return axios({
      url: "port/reporter/getReporterEntryFee",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ type })
    });
  }

  //个人中心-个人信息
  static GetPersonalData(userId) {
    return axios({
      url: "port/user/personalData",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId })
    });
  }

  //个人中心-我的收藏
  static MyCollectionList(videoModule, pageNum, pageSize, userId) {
    return axios({
      url: "port/user/getMyCollectionList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ videoModule, pageNum, pageSize, userId })
    });
  }
  //个人中心-我的投稿
  static gteMyManuscriptList(founder, pageNum, pageSize) {
    return axios({
      url: "port/user/myManuscriptList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ founder, pageNum, pageSize })
    });
  }
  //个人中心-我的Vlog
  static getMySchoolVlogList(founder, pageNum, pageSize) {
    return axios({
      url: "port/user/mySchoolVlogList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ founder, pageNum, pageSize })
    });
  }
  //个人中心-活动记录
  static MyActivityList(activityStatus, userId, pageNum, pageSize) {
    return axios({
      url: "port/user/getMyActivityList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ activityStatus, userId, pageNum, pageSize })
    });
  }

  //我的收藏里取消收藏
  static getCancelCollect(userId, relevanceId, collectType) {
    return axios({
      url: "port/user/cancelCollect",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId, relevanceId, collectType })
    });
  }
  //关键字搜索
  static searchLists(userId, keyWords) {
    return axios({
      url: "port/search/searchLists",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId, keyWords })
    });
  }

  //搜索记录的条件
  static gethistoryRecords(userId) {
    return axios({
      url: "port/search/historyRecords",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId })
    });
  }
  //根据模块筛选
  static getSearchListByModule(module, keyWords) {
    return axios({
      url: "port/search/searchListByModule",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ module, keyWords })
    });
  }
  //个人中心--我的积分列表
  static myScoreSheetList(userId) {
    return axios({
      url: "port/user/myScoreSheetList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId })
    });
  }

  //获取小记者身份信息
  static getReporterDetails(id) {
    return axios({
      url: "port/reporter/getReporterDetails",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }
  //获取数据字典类型
  static getDictDataList(dictType) {
    return axios({
      url: "port/index/getDictDataList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ dictType })
    });
  }
  //判断活动是否已报名
  static getIsActivityRecord(userId, activityId) {
    return axios({
      url: "port/reporter/isActivityRecord",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId, activityId })
    });
  }
  //优质稿件中的相关推荐
  static getManuScritpRelevantList(id) {
    return axios({
      url: "port/index/manuScritpRelevantList",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ id })
    });
  }
  //判断用户是不是小记者
  static getReporterData(userId) {
    return axios({
      url: "port/user/reporterData",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId })
    });
  }
  // 判断小记者是否可以续费
  static getIsRenew(userId) {
    return axios({
      url: "port/reporter/isRenew",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId })
    });
  }

  // 判断当前用户是否是新老用户
  static getIsOldUser(userId) {
    return axios({
      url: "port/reporter/isOldUser",
      method: "post",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      data: Qs.stringify({ userId })
    });
  }

  // http://192.168.1.91:8089/port/reporter/isRenew
}



// WEBPACK FOOTER //
// ./src/api/CheckInService.js